import React, { useState, ChangeEvent } from "react";
import { Button, Modal, Input, Radio, Divider, Select, Result } from "antd";
import { useHistory } from "react-router-dom";
import {
  useForm,
  useFormContext,
  SubmitHandler,
  Controller,
  Form,
  FormProvider,
} from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import "./add-modal.scss";
import { SelectBankModalProps } from "src/libraries/types/channel";
interface Field {
  name: string;
  type?: string;
  label: string;
  placeholder: string;
  rules: object;
  isSelect?: boolean;
  selectOptions?: SelectBankModalProps[];
}
interface CustomModalProps {
  title: string;
  isModalVisible: boolean;
  onOk: (data: Record<string, any>) => void;
  onCancel: () => void;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  fields: Field[];
}

const AddModal = ({
  fields,
  title,
  isModalVisible,
  onOk,
  onCancel,
}: CustomModalProps) => {
  const methods = useForm({
    mode: "onChange",
    criteriaMode: "all",
    defaultValues: fields.reduce((acc, field) => {
      acc[field.name] = ""; // Tạo giá trị mặc định cho mỗi field
      return acc;
    }, {} as Record<string, any>),
  });
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = methods;
  const history = useHistory();
  // kiểm tra nếu có ít nhất 1 thông tin trong fields có options là rỗng (tức chưa có ngân hàng) => hiện thông báo
  const hasEmptyOptions = fields.some(
    (item) =>
      Array.isArray(item.selectOptions) && item.selectOptions.length === 0
  );
  return (
    <FormProvider {...methods}>
      <Modal
        okButtonProps={{ size: "large", disabled: hasEmptyOptions }}
        cancelButtonProps={{ size: "large" }}
        width={800}
        styles={{ body: { height: hasEmptyOptions ? "300px" : "200px" } }}
        open={isModalVisible}
        title={title}
        okText="Tiếp tục"
        cancelText="Hủy"
        onCancel={onCancel}
        onOk={handleSubmit(onOk)}
      >
        <Divider />
        {!hasEmptyOptions ? (
          <Form>
            {fields.map((item) => (
              <div key={`#${item.name}`} className="modal-content">
                <div className="modal-label">{item.label}</div>
                <div style={{ position: "relative" }} className="modal-item">
                  {item.isSelect ? (
                    item.selectOptions && item.selectOptions.length > 0 ? (
                      <Controller
                        name={item.name}
                        control={control}
                        rules={item.rules}
                        render={({ field }) => (
                          <Select
                            size="large"
                            options={item.selectOptions}
                            placeholder={item.placeholder}
                            {...field}
                          />
                        )}
                      />
                    ) : (
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <p>
                          Danh sách rỗng. Vui lòng thêm dữ liệu để tiếp tục.
                        </p>
                        <button onClick={() => history.push("/bank")}>
                          Chuyển đến trang thêm dữ liệu
                        </button>
                      </div>
                    )
                  ) : (
                    <Controller
                      name={item.name}
                      control={control}
                      rules={item.rules}
                      render={({ field }) => (
                        <Input
                          size="large"
                          type={item.type}
                          placeholder={item.placeholder}
                          {...field}
                        />
                      )}
                    />
                  )}
                  <ErrorMessage
                    errors={errors}
                    name={item.name}
                    render={({ message }) => (
                      <p
                        style={{
                          color: "red",
                          marginBottom: 20,
                          position: "absolute",
                          top: "100%" /* Hiển thị thông báo lỗi ngay dưới trường input */,
                          left: 0,
                        }}
                      >
                        {message}
                      </p>
                    )}
                  />
                </div>
              </div>
            ))}
          </Form>
        ) : (
          <Result
            status="warning"
            title="Bạn chưa có tài khoản ngân hàng nào."
            extra={
              <Button
                onClick={() => history.push("/bank")}
                type="primary"
                key="console"
              >
                Tạo mới tài khoản
              </Button>
            }
          />
        )}
      </Modal>
    </FormProvider>
  );
};

export default AddModal;
